import { useMemo } from 'react'
import { VictoryArea, VictoryChart, VictoryGroup, VictoryPolarAxis, VictoryScatter } from 'victory'

import { IRQCategorySeverity } from '@/gen/inventory/v1/company_service_pb'
import { RiskLevel } from '@/gen/inventory/v1/risk_pb'

import { victoryPolarChartTheme } from '@/const/theme'

import { riskLevelToColor } from '@/lib/ui/color'

export type InherentRiskChartProps = {
  companyRisk: RiskLevel
  irqCategorySeverities: IRQCategorySeverity[]
}

export const InherentRiskChart = ({
  companyRisk,
  irqCategorySeverities,
}: InherentRiskChartProps) => {
  const chart = useMemo(() => {
    return irqCategorySeverities.map(({ category, severity }) => ({
      x: category,
      y: severity,
    }))
  }, [irqCategorySeverities])

  if (chart.length === 0) return null

  return (
    <VictoryChart
      polar
      theme={victoryPolarChartTheme}
      domain={{ y: [RiskLevel.UNSPECIFIED, RiskLevel.CRITICAL] }}
    >
      {chart.map(({ x }, i) => {
        return (
          <VictoryPolarAxis
            dependentAxis
            key={i}
            label={x.replace(' ', '\n')}
            labelPlacement='vertical'
            style={{
              axisLabel: { padding: 15 },
              tickLabels: { fill: 'none' },
            }}
            axisValue={x}
          />
        )
      })}
      <VictoryGroup data={chart}>
        <VictoryArea
          style={{
            data: { fillOpacity: 0.1, strokeWidth: 1, fill: riskLevelToColor[companyRisk] },
          }}
        />
        <VictoryScatter
          style={{
            data: { fill: riskLevelToColor[companyRisk] },
          }}
        />
      </VictoryGroup>
    </VictoryChart>
  )
}
